var map = {
	"./emoji_u1f336.png": 9517,
	"./emoji_u1f346.png": 5592,
	"./emoji_u1f349.png": 4619,
	"./emoji_u1f351.png": 8269,
	"./emoji_u1f354.png": 5042,
	"./emoji_u1f355.png": 4833,
	"./emoji_u1f383.png": 5174,
	"./emoji_u1f418.png": 8683,
	"./emoji_u1f94e.png": 9729,
	"./emoji_u1f94f.png": 3080,
	"./emoji_u1f97e.png": 3093,
	"./emoji_u1f99a.png": 6203,
	"./emoji_u1f99c.png": 4219,
	"./emoji_u1f99d.png": 4791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6715;